document.addEventListener("DOMContentLoaded", () => {
  /** @type {HTMLDialogElement|null} */
  const modal = document.querySelector("[data-mte-product-zoom]");

  if (!modal) return;

  /** @type {HTMLImageElement|null} */
  const zoomImage = modal.querySelector("[data-mte-zoom-image]");

  /** @type {HTMLButtonElement|null} */
  const closeButton = modal.querySelector("[data-mte-zoom-close]");

  /** @type {HTMLButtonElement|null} */
  const zoomInButton = modal.querySelector("[data-mte-zoom-in]");

  /** @type {HTMLButtonElement|null} */
  const zoomOutButton = modal.querySelector("[data-mte-zoom-out]");

  /** @type {HTMLButtonElement|null} */
  const resetButton = modal.querySelector("[data-mte-zoom-reset]");

  if (!zoomImage) return;

  let scale = 1;
  let translateX = 0;
  let translateY = 0;

  let isDragging = false;
  let startX = 0;
  let startY = 0;

  const minimumScale = 1;
  const maximumScale = 4;
  const scaleStep = 0.35;

  const updateTransform = () => {
    zoomImage.style.transform = `
      translate(${translateX}px, ${translateY}px)
      scale(${scale})
    `;

    zoomImage.classList.toggle("is-zoomed", scale > 1);
  };

  const resetZoom = () => {
    scale = 1;
    translateX = 0;
    translateY = 0;
    updateTransform();
  };

  const setScale = (nextScale) => {
    scale = Math.min(
      maximumScale,
      Math.max(minimumScale, nextScale),
    );

    if (scale === 1) {
      translateX = 0;
      translateY = 0;
    }

    updateTransform();
  };

  document.addEventListener("click", (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const clickedImage = target.closest(
      "[data-mte-product-slide] img",
    );

    if (
      clickedImage instanceof HTMLImageElement &&
      clickedImage.closest("[data-mte-product]")
    ) {
      const highResolutionSource =
        clickedImage.currentSrc ||
        clickedImage.src;

      zoomImage.src = highResolutionSource;
      zoomImage.alt = clickedImage.alt || "";

      resetZoom();
      modal.showModal();
      document.body.classList.add("mte-zoom-is-open");
      return;
    }

    if (
      target.closest("[data-mte-zoom-close]") ||
      target === modal
    ) {
      modal.close();
    }
  });

  closeButton?.addEventListener("click", () => {
    modal.close();
  });

  zoomInButton?.addEventListener("click", () => {
    setScale(scale + scaleStep);
  });

  zoomOutButton?.addEventListener("click", () => {
    setScale(scale - scaleStep);
  });

  resetButton?.addEventListener("click", resetZoom);

  zoomImage.addEventListener(
    "wheel",
    (event) => {
      event.preventDefault();

      if (event.deltaY < 0) {
        setScale(scale + scaleStep);
      } else {
        setScale(scale - scaleStep);
      }
    },
    {
      passive: false,
    },
  );

  zoomImage.addEventListener("dblclick", () => {
    if (scale > 1) {
      resetZoom();
    } else {
      setScale(2);
    }
  });

  zoomImage.addEventListener("pointerdown", (event) => {
    if (scale <= 1) return;

    isDragging = true;
    startX = event.clientX - translateX;
    startY = event.clientY - translateY;

    zoomImage.setPointerCapture(event.pointerId);
    zoomImage.classList.add("is-dragging");
  });

  zoomImage.addEventListener("pointermove", (event) => {
    if (!isDragging || scale <= 1) return;

    translateX = event.clientX - startX;
    translateY = event.clientY - startY;

    updateTransform();
  });

  zoomImage.addEventListener("pointerup", (event) => {
    isDragging = false;
    zoomImage.classList.remove("is-dragging");

    if (zoomImage.hasPointerCapture(event.pointerId)) {
      zoomImage.releasePointerCapture(event.pointerId);
    }
  });

  zoomImage.addEventListener("pointercancel", () => {
    isDragging = false;
    zoomImage.classList.remove("is-dragging");
  });

  modal.addEventListener("close", () => {
    document.body.classList.remove("mte-zoom-is-open");

    resetZoom();

    zoomImage.removeAttribute("src");
    zoomImage.alt = "";
  });
});